import { NgModule } from '@angular/core';
import { ModusInput } from './modus-input.directive';

@NgModule({
  declarations: [ModusInput],
  exports: [ModusInput],
})
export class ModusInputModule {}
